export function getClientPointFromEvent(event) {
  const touch = event.touches?.[0] || event.changedTouches?.[0];
  if (touch) {
    return { x: touch.clientX, y: touch.clientY };
  }

  if (typeof event.clientX === 'number' && typeof event.clientY === 'number') {
    return { x: event.clientX, y: event.clientY };
  }

  return null;
}

function preventTouchDefaults(event) {
  if (event.cancelable) {
    event.preventDefault();
  }
}

export function buildUnifiedEventHandlers({ onStart, onMove, onEnd, onCancel }) {
  return {
    onMouseDown: (event) => onStart?.(event, 'mouse'),
    onMouseMove: (event) => onMove?.(event, 'mouse'),
    onMouseUp: (event) => onEnd?.(event, 'mouse'),
    onMouseLeave: (event) => onCancel?.(event, 'mouse'),
    onTouchStart: (event) => {
      preventTouchDefaults(event);
      onStart?.(event, 'touch');
    },
    onTouchMove: (event) => {
      preventTouchDefaults(event);
      onMove?.(event, 'touch');
    },
    onTouchEnd: (event) => {
      preventTouchDefaults(event);
      onEnd?.(event, 'touch');
    },
    onTouchCancel: (event) => {
      preventTouchDefaults(event);
      onCancel?.(event, 'touch');
    },
  };
}

